
import { mapState, mapActions, mapGetters } from 'vuex';
import AppHeaderV2ProductScore from './AppHeaderV2ProductScore';
import AppHeaderV2ProductScoreHistogram from './AppHeaderV2ProductScoreHistogram';
import AppHeaderV2EvaluationTypeGraph from './AppHeaderV2EvaluationTypeGraph';

export default {
  name: 'AppHeaderV2ScoreSection',
  components: {
    AppHeaderV2ProductScore,
    AppHeaderV2ProductScoreHistogram,
    AppHeaderV2EvaluationTypeGraph
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('productScoreSummary', ['isLoadingScoreSummary']),
    ...mapGetters('evaluationTypeStatistics', [
      'evaluationTypeStatisticsShowable'
    ]),
    ...mapGetters('widget', ['device', 'isMobileViewport', 'isPcViewport']),
    useOnlyScore() {
      return (
        this.widget.show_product_score &&
        !this.widget.show_product_score_histogram &&
        !this.showEvaluationGraph
      );
    },
    showEvaluationGraph() {
      return (
        this.widget.show_evaluation_option_type_graph &&
        this.evaluationTypeStatisticsShowable
      );
    },
    showTopEvaluationGraph() {
      return (
        (!this.widget.show_product_score_histogram || this.isPcViewport) &&
        this.showEvaluationGraph
      );
    },
    showBottomEvalutationGraph() {
      return (
        !this.isPcViewport &&
        this.widget.show_product_score_histogram &&
        this.showEvaluationGraph
      );
    },
    hideDashedLine() {
      return (
        this.isMobileViewport &&
        this.widget.show_product_score &&
        this.widget.show_evaluation_option_type_graph
      );
    }
  },
  created() {
    this.fetchProductScoreSummary({ fields: 'scores_map' });
    this.fetchEvaluationTypeStatistics();
  },
  methods: {
    ...mapActions('productScoreSummary', ['fetchProductScoreSummary']),
    ...mapActions('evaluationTypeStatistics', ['fetchEvaluationTypeStatistics'])
  }
};
